import styled from 'styled-components';

const Container = styled("div")`
    width: 100%;
    height: 100px;
    background-color: #af48ca;

    display: flex;
    justify-content: center;
    align-items: center;
`

const Title = styled("h1")`
    margin: 0;
`

const Navbar = () => {
    return (
        <Container>
            <Title>
                Derugged Godz
            </Title>
        </Container>
    )
}

export default Navbar;
